// extracted by mini-css-extract-plugin
export default {"label":"style_label__92RmD","c":"style_c__S4cM2","e":"style_e__gi-qF","icon":"style_icon__6kEQE"};